/* ═══════════════════════════════════════════
   PINE PARK ARCADE: theme.js
   Vanilla JS only. No jQuery.
   ═══════════════════════════════════════════ */

(function () {
  'use strict';

  /* ══════════════════════════════════════
     1. INTERSECTION OBSERVER: SCROLL REVEAL
     Adds .active to .power-up elements as
     they enter the viewport.
     ══════════════════════════════════════ */
  function initScrollReveal() {
    var targets = document.querySelectorAll('.power-up');
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () {
              entry.target.classList.add('active');
            }, i * 100);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ══════════════════════════════════════
     2. MOBILE MENU (up to 900px)
     The toggle opens #navLinks as a panel over the backdrop and locks the
     page scroll (CLAUDE.md rule 4). A sub list (SHOP) opens from its own
     toggle, starts shut each time the menu opens, and never closes the
     menu. The menu closes on the toggle, the backdrop, Escape, any link in
     the nav, the PLAY button and a resize past 900px.
     ══════════════════════════════════════ */
  function initMobileMenu() {
    var toggle = document.querySelector('.mobile-toggle');
    var navLinks = document.getElementById('navLinks');
    if (!toggle || !navLinks) return;

    var nav = document.querySelector('nav');
    var backdrop = document.querySelector('[data-nav-backdrop]');
    var icon = toggle.querySelector('.mobile-toggle-icon');
    var text = toggle.querySelector('.mobile-toggle-text');
    var subToggles = navLinks.querySelectorAll('.nav-sub-toggle');
    var wideQuery = window.matchMedia ? window.matchMedia('(min-width: 901px)') : null;
    var isOpen = false;
    var savedY = 0;
    var i;

    function isWide() {
      return wideQuery ? wideQuery.matches : window.innerWidth > 900;
    }

    function shutSubs() {
      for (var j = 0; j < subToggles.length; j++) {
        subToggles[j].setAttribute('aria-expanded', 'false');
      }
    }

    function lockScroll() {
      savedY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedY + 'px';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      var root = document.documentElement;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      /* html is scroll-behavior: smooth (base.css): jump back, do not glide. */
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, savedY);
      root.style.scrollBehavior = '';
    }

    function setToggle(open) {
      var label = toggle.getAttribute(open ? 'data-label-close' : 'data-label-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) toggle.setAttribute('aria-label', label);
      if (icon) icon.textContent = open ? '✕' : '☰';
      if (text) text.textContent = open ? 'CLOSE' : 'MENU';
    }

    function openMenu() {
      if (isOpen) return;
      isOpen = true;
      shutSubs();
      navLinks.classList.add('open');
      if (backdrop) backdrop.classList.add('is-open');
      setToggle(true);
      lockScroll();
    }

    function closeMenu() {
      if (!isOpen) return;
      isOpen = false;
      navLinks.classList.remove('open');
      if (backdrop) backdrop.classList.remove('is-open');
      setToggle(false);
      unlockScroll();
    }

    toggle.addEventListener('click', function () {
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (backdrop) backdrop.addEventListener('click', closeMenu);

    for (i = 0; i < subToggles.length; i++) {
      subToggles[i].addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    }

    /* Menu rows, the logo, CART and PLAY. Capture phase, so the scroll is
       back before game.js reads window.scrollY for its own lock. */
    if (nav) {
      nav.addEventListener('click', function (e) {
        var el = e.target;
        if (!isOpen) return;
        while (el && el !== nav) {
          if (el.nodeType === 1 && (el.tagName === 'A' || el.hasAttribute('data-game-btn'))) {
            closeMenu();
            return;
          }
          el = el.parentNode;
        }
      }, true);
    }

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        closeMenu();
        toggle.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (isOpen && isWide()) closeMenu();
    });
  }

  /* ══════════════════════════════════════
     3. FAQ ACCORDION
     Click to toggle .open class on .faq-item,
     keeping aria-expanded on the button in sync
     ══════════════════════════════════════ */
  function initFAQ() {
    var items = document.querySelectorAll('.faq-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var question = item.querySelector('.faq-question');
      if (!question) return;

      question.addEventListener('click', function () {
        // Close other open items (optional accordion behavior)
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('open');
            var otherQuestion = other.querySelector('.faq-question');
            if (otherQuestion) {
              otherQuestion.setAttribute('aria-expanded', 'false');
            }
          }
        });
        item.classList.toggle('open');
        question.setAttribute(
          'aria-expanded',
          item.classList.contains('open') ? 'true' : 'false'
        );
      });
    });
  }

  /* ══════════════════════════════════════
     4. KONAMI CODE EASTER EGG
     ↑↑↓↓←→←→BA triggers a hue-rotate
     ══════════════════════════════════════ */
  function initKonamiCode() {
    var code = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];
    var index = 0;

    document.addEventListener('keydown', function (e) {
      if (e.keyCode === code[index]) {
        index++;
        if (index === code.length) {
          document.body.style.filter = 'hue-rotate(180deg) saturate(2)';
          setTimeout(function () {
            document.body.style.filter = '';
          }, 3000);
          index = 0;
        }
      } else {
        index = 0;
      }
    });
  }

  /* ══════════════════════════════════════
     5. HOMEPAGE LOADING SCREEN
     Animates a progress bar, then hides
     ══════════════════════════════════════ */
  function initLoadingScreen() {
    var bar = document.getElementById('loadingBar');
    var percent = document.getElementById('loadingPercent');
    var screen = document.getElementById('loadingScreen');
    if (!bar || !percent || !screen) return;

    var progress = 0;
    var interval = setInterval(function () {
      progress += Math.random() * 15 + 5;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
        setTimeout(function () {
          screen.classList.add('hidden');
        }, 300);
      }
      bar.style.width = progress + '%';
      percent.textContent = Math.floor(progress) + '%';
    }, 120);
  }

  /* ══════════════════════════════════════
     6. NAV BACKGROUND ON SCROLL
     Adds .nav-scrolled when past 50px
     ══════════════════════════════════════ */
  function initNavScroll() {
    var nav = document.querySelector('nav');
    if (!nav) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        nav.classList.add('nav-scrolled');
      } else {
        nav.classList.remove('nav-scrolled');
      }
    });
  }

  /* ══════════════════════════════════════
     7. HERO STAR GENERATION
     Creates random twinkling star divs
     ══════════════════════════════════════ */
  function initStars() {
    var container = document.getElementById('stars');
    if (!container) return;

    for (var i = 0; i < 80; i++) {
      var star = document.createElement('div');
      star.classList.add('star');
      star.style.left = Math.random() * 100 + '%';
      star.style.top = Math.random() * 100 + '%';
      star.style.animationDelay = Math.random() * 3 + 's';
      star.style.animationDuration = (Math.random() * 2 + 2) + 's';
      var size = (Math.random() * 2 + 1) + 'px';
      star.style.width = size;
      star.style.height = size;
      container.appendChild(star);
    }
  }

  /* ══════════════════════════════════════
     8. PARALLAX SUN (Homepage hero)
     ══════════════════════════════════════ */
  function initParallaxSun() {
    var sun = document.querySelector('.retro-sun');
    if (!sun) return;

    window.addEventListener('scroll', function () {
      var scroll = window.scrollY;
      sun.style.transform = 'translateX(-50%) translateY(' + scroll * 0.3 + 'px)';
    });
  }

  /* ══════════════════════════════════════
     9. FILTER BUTTONS (Collections page)
     Toggle .active class on filter buttons
     ══════════════════════════════════════ */
  function initFilterButtons() {
    var buttons = document.querySelectorAll('.filter-btn');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');
        // In production, this would filter products via Shopify tags/AJAX
      });
    });
  }

  /* ══════════════════════════════════════
     10. CONTACT FORM SUBMIT ANIMATION
     ══════════════════════════════════════ */
  function initContactForm() {
    var submitBtn = document.querySelector('.form-submit');
    if (!submitBtn) return;

    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var btn = this;
      btn.textContent = 'SENDING...';
      btn.style.background = 'var(--neon-yellow)';
      setTimeout(function () {
        btn.textContent = 'MESSAGE SENT \u2713';
        btn.style.background = 'var(--neon-green)';
      }, 1500);
      setTimeout(function () {
        btn.textContent = 'SEND MESSAGE \u25B6';
        btn.style.background = '';
      }, 4000);
    });
  }

  /* ══════════════════════════════════════
     11. AJAX ADD TO CART
     POST to /cart/add.js, update cart count
     ══════════════════════════════════════ */
  function initAjaxCart() {
    /* The cart drawer (assets/cart-drawer.js, CLAUDE.md rule 68) replaced the
       post-add sheet in mobile Phase 7. Every add on the card mechanism comes
       through here and hands the result to window.PinePark.cartDrawer; the
       add body carries the drawer's section parameters so the response
       brings the re-rendered drawer with it. Without the drawer the count
       still updates. */
    function drawerApi() {
      return (window.PinePark && window.PinePark.cartDrawer) || null;
    }

    /* PDP quantity bug: this handler calls preventDefault(), so the product
       form's name="quantity" field is never serialized. Read it off the form
       directly; card buttons have no form and fall back to data-quantity. */
    function findQuantityInput(btn) {
      var form = btn.closest('form');
      return form ? form.querySelector('[name="quantity"]') : null;
    }

    function readAddQuantity(btn) {
      var input = findQuantityInput(btn);
      var raw = input ? input.value : btn.getAttribute('data-quantity');
      var qty = parseInt(raw, 10);
      if (isNaN(qty) || qty < 1) return 1;
      if (qty > 99) return 99;
      return qty;
    }

    /* A button may name a mirror by id in data-add-mirror (the PDP sticky bar does).
       Every label and disabled write in the add lifecycle goes through here so the
       mirror shows the same state. Cards carry no mirror and are unchanged. */
    function setAddState(btn, text, disabled) {
      btn.textContent = text;
      btn.disabled = disabled;
      var mirrorId = btn.getAttribute('data-add-mirror');
      var mirror = mirrorId ? document.getElementById(mirrorId) : null;
      if (mirror) {
        mirror.textContent = text;
        mirror.disabled = disabled;
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      var qtyInput = findQuantityInput(btn);
      var qty = readAddQuantity(btn);

      if (!variantId) return;

      setAddState(btn, 'ADDING...', true);

      var drawer = drawerApi();
      var body = drawer ? drawer.sectionParams() : {};
      body.id = parseInt(variantId, 10);
      body.quantity = qty;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          /* A refused add (sold out, over stock) answers 422 with Shopify's
             own description, which the drawer shows as its one error line. */
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function (item) {
          setAddState(btn, 'ADDED \u2713', true);
          /* Reset so a second add does not silently repeat the quantity. */
          if (qtyInput) qtyInput.value = 1;
          if (drawer) {
            drawer.added(item, btn.getAttribute('data-display-name'));
          } else {
            updateCartCount();
          }
          setTimeout(function () {
            setAddState(btn, 'ADD TO CART', false);
          }, 1500);
        })
        .catch(function (err) {
          setAddState(btn, 'ERROR', true);
          /* Shopify's description only: a network error's message is never shown. */
          if (drawer) drawer.failed(err && err.description);
          setTimeout(function () {
            setAddState(btn, 'ADD TO CART', false);
          }, 1500);
        });
    });
  }

  function updateCartCount() {
    fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count]');
        if (countEls.length) {
          countEls.forEach(function (el) {
            el.textContent = cart.item_count;
          });
        } else {
          // Span was removed; fall back to rewriting the nav text
          var navCart = document.querySelector('.nav-cart');
          if (navCart) {
            navCart.textContent = 'CART [' + cart.item_count + ']';
          }
        }
      })
      .catch(function () {});
  }


  /* ══════════════════════════════════════
     13. CART QUANTITY UPDATE
     PATCH to /cart/change.js
     ══════════════════════════════════════ */
  function initCartQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-quantity]');
      if (!btn) return;
      e.preventDefault();

      var action = btn.getAttribute('data-cart-quantity'); // "plus" or "minus"
      var lineKey = btn.getAttribute('data-line-key');
      var qtyInput = document.querySelector('[data-quantity-input="' + lineKey + '"]');
      if (!qtyInput || !lineKey) return;

      var currentQty = parseInt(qtyInput.value, 10);
      var newQty = action === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);

      qtyInput.value = newQty;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          // Reload to reflect updated totals (simple approach)
          window.location.reload();
        })
        .catch(function () {
          // Revert on failure
          qtyInput.value = currentQty;
        });
    });
  }

  /* ══════════════════════════════════════
     14. PRODUCT CAROUSEL: Prev / Next
     Mobile  (≤768px): native scrollBy() on the scroll container.
                       scroll-snap-type handles clean card snapping.
     Desktop (>768px): CSS transform: translateX() on the track.
                       The track has overflow:visible so it is NOT a
                       scroll container, mouse-wheel / trackpad vertical
                       scroll CANNOT be hijacked by it.  Navigation is
                       purely button-driven via translateX offset.
     ══════════════════════════════════════ */
  function initCarousels() {
    var wrappers = document.querySelectorAll('[data-carousel]');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var id = wrapper.getAttribute('data-carousel');
      var track = wrapper.querySelector('[data-carousel-track="' + id + '"]');
      var viewport = wrapper.querySelector('.carousel-viewport');
      var prevBtns = wrapper.querySelectorAll('[data-carousel-prev="' + id + '"]');
      var nextBtns = wrapper.querySelectorAll('[data-carousel-next="' + id + '"]');
      if (!track) return;

      /* Desktop transform state */
      var currentOffset = 0;

      function isMobile() {
        return window.innerWidth <= 768;
      }

      /* One slide width + gap, the amount to advance per button click */
      function getSlideWidth() {
        var slide = track.querySelector('.carousel-slide');
        if (!slide) return 300;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.gap) || 24;
        return slide.offsetWidth + gap;
      }

      /* Maximum translateX offset so we never scroll past the last card.
         Sums actual slide widths instead of relying on scrollWidth, which
         is unreliable when overflow:visible (element is not a scroll container). */
      function getMaxOffset() {
        if (!viewport) return 0;
        var slides = track.querySelectorAll('.carousel-slide');
        var style = getComputedStyle(track);
        var gap = parseFloat(style.gap) || 24;
        var totalWidth = 0;
        slides.forEach(function (s) { totalWidth += s.offsetWidth + gap; });
        totalWidth -= gap; /* remove the trailing gap after the last card */
        return Math.max(0, totalWidth - viewport.offsetWidth);
      }

      function navigate(direction) {
        if (isMobile()) {
          /* Mobile: native smooth scroll; CSS scroll-snap snaps cleanly */
          track.scrollBy({ left: direction * getSlideWidth(), behavior: 'smooth' });
        } else {
          /* Desktop: clamp offset within [0, max] and apply as transform */
          var step = getSlideWidth();
          var max = getMaxOffset();
          currentOffset = Math.max(0, Math.min(max, currentOffset + direction * step));
          track.style.transform = 'translateX(-' + currentOffset + 'px)';
        }
      }

      prevBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { navigate(-1); });
      });

      nextBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { navigate(1); });
      });

      /* On resize (e.g. rotate or dev-tools breakpoint change) reset the
         transform so the carousel doesn't sit in a broken mid-slide state. */
      window.addEventListener('resize', function () {
        currentOffset = 0;
        track.style.transform = '';
      });
    });
  }

  /* ══════════════════════════════════════
     15. NEON COLOR TAG PARSER
     Syntax: [pink]Word [cyan]Word
     Parses color tags in any element with
     data-neon-title and wraps segments in
     colored <span>s with neon glow.
     data-neon-default = fallback color for
     un-tagged text (from heading_color picker).
     ══════════════════════════════════════ */
  function initNeonTitles() {
    var MAP = {
      pink:   'var(--neon-pink)',
      cyan:   'var(--neon-cyan)',
      purple: 'var(--neon-purple)',
      green:  'var(--neon-green)',
      yellow: 'var(--neon-yellow)',
      white:  '#ffffff',
      muted:  '#8070b0'
    };
    var els = document.querySelectorAll('[data-neon-title]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var raw = el.textContent.trim();
      if (raw.indexOf('[') === -1) continue;
      var defaultColor = el.getAttribute('data-neon-default') || '';
      var parts = raw.split(/\[([a-z]+)\]/);
      var html = '';
      var color = defaultColor;
      for (var j = 0; j < parts.length; j++) {
        if (j % 2 === 1) {
          color = MAP[parts[j]] || defaultColor;
        } else {
          var text = parts[j];
          if (!text) continue;
          var tmp = document.createElement('span');
          tmp.textContent = text;
          var safe = tmp.innerHTML;
          if (color) {
            html += '<span style="color:' + color + ';text-shadow:0 0 20px ' + color + ',0 0 45px ' + color + '">' + safe + '</span>';
          } else {
            html += safe;
          }
        }
      }
      el.innerHTML = html;
      el.setAttribute('data-neon-html', html);
    }
  }

  /* ══════════════════════════════════════
     15. CARD HOVER VIDEO
     Product cards may carry a <video> sibling of the image
     (data-video-src set, no src). On mouseenter: 150ms
     debounce, then set src once and play. On mouseleave:
     pause, rewind, clear the timer. The crossfade itself is
     CSS (.product-card:hover .product-img--video), so this
     only drives playback. Nothing runs until the pointer
     enters a card, so cards still at opacity 0 under
     .power-up are never touched on load.
     ══════════════════════════════════════ */
  function initCardHoverVideo() {
    var videos = document.querySelectorAll('.product-card video[data-video-src]');
    if (!videos.length) return;

    videos.forEach(function (video) {
      var card = video.closest('.product-card');
      if (!card) return;
      var timer = null;

      function playVideo() {
        timer = null;
        if (!video.getAttribute('src')) {
          video.setAttribute('src', video.getAttribute('data-video-src'));
        }
        var p = video.play();
        // play() returns a promise; a blocked/interrupted play must not
        // surface as an uncaught rejection in the console.
        if (p && typeof p.catch === 'function') {
          p.catch(function () {});
        }
      }

      card.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        timer = setTimeout(playVideo, 150);
      });

      card.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = null;
        video.pause();
        try { video.currentTime = 0; } catch (err) {}
      });
    });
  }

  /* ══════════════════════════════════════
     16. SIGNUPS WITHOUT A RELOAD (mobile Phase 8, Batch 13; CLAUDE.md rule 71)
     The email signups (footer, newsletter section, the grid's
     drop-notify band and the age gate) are Shopify customer
     forms marked data-bg-signup. Shopify's storefront hCaptcha
     binds a form on its first focus: it keeps the form's submit
     method as it finds it, puts its own in its place, and calls
     the kept one once it has a token. So this sets form.submit
     before that happens, and the token's POST goes out in the
     background with the same form data, to the same action.
     Success (the reply lands on customer_posted=true or carries
     the form's data-signup-ok) replaces the form in place with
     one line of the same height. Shopify's errors show inline in
     plain words. A challenge (the reply lands on /challenge),
     any other reply or a network failure falls back to the
     native submit, so the challenge page works as it always did.
     Without spam protection on the page there is no hCaptcha to
     call submit, so the form's own submit event starts the POST.
     The age gate (data-bg-signup="gate") keeps its own flow in
     assets/age-gate-modal.js, which shows its success and closes;
     here it only gets the background POST and its error line.
     A form hCaptcha bound before this ran is left alone (it
     submits the old way). No JavaScript: the forms post as ever.
     ══════════════════════════════════════ */
  var SIGNUP_DONE = 'You’re in. Watch your inbox for drops.';

  function signupPlainError(text) {
    var t = (text || '').toLowerCase();
    if (t.indexOf('taken') !== -1 || t.indexOf('already') !== -1) {
      return 'You’re already on the list.';
    }
    if (t.indexOf('invalid') !== -1 || t.indexOf('blank') !== -1) {
      return 'That email doesn’t look right. Check it and try again.';
    }
    t = (text || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
    return t || 'That didn’t go through. Please try again.';
  }

  /* The error line under the field. The age gate's is its own error span
     (data-signup-error="keep"), which its script also writes and which
     stays in the tree; the others are hidden while empty. */
  function signupError(form, text) {
    var slot = form.querySelector('[data-signup-error]');
    if (!slot) return;
    slot.textContent = text || '';
    if (slot.getAttribute('data-signup-error') !== 'keep') slot.hidden = !text;
  }

  /* The line takes the form's box: its classes (the footer places the form
     in its grid by class), its height and its margins, so nothing moves. */
  function signupDone(form) {
    var style = window.getComputedStyle(form);
    var hadFocus = form.contains(document.activeElement);
    var msg = document.createElement('p');
    msg.className = (form.className ? form.className + ' ' : '') + 'signup-done';
    msg.setAttribute('role', 'status');
    msg.setAttribute('tabindex', '-1');
    msg.textContent = SIGNUP_DONE;
    msg.style.cssText = 'display:flex;align-items:center;justify-content:center;box-sizing:border-box;' +
      'padding:0;text-align:center;font-family:var(--font-body);font-size:0.875rem;line-height:1.4;' +
      'color:var(--neon-green);outline:none;';
    msg.style.minHeight = form.getBoundingClientRect().height + 'px';
    msg.style.marginTop = style.marginTop;
    msg.style.marginRight = style.marginRight;
    msg.style.marginBottom = style.marginBottom;
    msg.style.marginLeft = style.marginLeft;
    form.parentNode.replaceChild(msg, form);
    if (hadFocus) msg.focus();
  }

  function signupPost(form, nativeSubmit) {
    if (form.getAttribute('data-signup-busy')) return;
    var gate = form.getAttribute('data-bg-signup') === 'gate';
    var btn = form.querySelector('[type="submit"]');
    form.setAttribute('data-signup-busy', '1');
    if (btn && !gate) btn.disabled = true;
    signupError(form, '');

    function settle() {
      form.removeAttribute('data-signup-busy');
      if (btn && !gate) btn.disabled = false;
    }
    function fallback() {
      settle();
      nativeSubmit.call(form);
    }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (res) {
      var url = res.url || '';
      if (!res.ok || url.indexOf('/challenge') !== -1) return fallback();
      return res.text().then(function (html) {
        var doc = new window.DOMParser().parseFromString(html, 'text/html');
        var twin = form.id ? doc.getElementById(form.id) : null;
        var err = twin ? twin.querySelector('[data-signup-errors]') : null;
        if (err) {
          settle();
          signupError(form, signupPlainError(err.textContent));
          return;
        }
        if (url.indexOf('customer_posted=true') !== -1 || (twin && twin.querySelector('[data-signup-ok]'))) {
          settle();
          if (!gate) signupDone(form);
          return;
        }
        fallback();
      });
    }).catch(fallback);
  }

  function initSignups() {
    var forms = document.querySelectorAll('form[data-bg-signup]');
    if (!forms.length || !window.fetch || !window.FormData || !window.DOMParser) return;
    var nativeSubmit = window.HTMLFormElement.prototype.submit;
    var captcha = !!(window.Shopify && window.Shopify.captcha);

    Array.prototype.forEach.call(forms, function (form) {
      if (form.getAttribute('data-hcaptcha-bound')) return;
      try {
        form.submit = function () { signupPost(form, nativeSubmit); };
      } catch (e) {
        return;
      }
      var input = form.querySelector('input[type="email"]');
      if (input) {
        input.addEventListener('input', function () { signupError(form, ''); });
      }
      if (!captcha && form.getAttribute('data-bg-signup') !== 'gate') {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          signupPost(form, nativeSubmit);
        });
      }
    });
  }

  /* ══════════════════════════════════════
     INIT: Run everything on DOMContentLoaded
     ══════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    initNeonTitles();
    initScrollReveal();
    initMobileMenu();
    initFAQ();
    initKonamiCode();
    initLoadingScreen();
    initNavScroll();
    initStars();
    initParallaxSun();
    initFilterButtons();
    initContactForm();
    initAjaxCart();
    initCartQuantity();
    initCarousels();
    initCardHoverVideo();
    initSignups();
  });
})();
